import BaseReportPDFSettingsPreview from "../BaseReportPDFSettingsPreview";

export default class PDFSettingsPreview extends BaseReportPDFSettingsPreview {
    constructor($containerEl, lightboxId, eventNamespace) {
        super($containerEl, lightboxId)
        this.eventNamespace = eventNamespace;
    }

    getStore() {
        return EVAReport.Store;
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/estimatedVsActualReport/PDFSettingsPreview.js